<!--suppress ALL -->
<template>
  <g-field :label="title" :type="type" :message="message" class="auto-complete">
    <g-autocomplete v-model="pendaftarNameFormated" :data="pendaftarFilter"
                    field="nama_lengkap" :placeholder="placeholder"
                    @select="onSelectStaff" open-on-focus :isLoading="isLoading">
      <span slot="iconRight" class="tooltip" :data-tooltip="$t('text.reset_search')"
            :class="pendaftars.length === 0 && applySearchOnType ? '' : 'is-hidden'"
            @click="onResetOnTypeSearch">
          <i class="far fa-times"></i>
      </span>

      <div slot-scope="{option}" class="media">
        <div class="media-content">
          <strong>{{ option.nama_lengkap }}</strong>
          <br>
          <small>
            <span>{{ option.nomor || "-" }}</span>
            <br>
            <span>{{ option.orang_tua || "-" }}</span>
          </small>
        </div>
      </div>

      <div slot="empty" class="has-text-centered">
        <p class="title is-6">{{ $t("text.no_content_loaded") }}</p>
      </div>

      <div slot="footer" class="has-text-centered"
           :class="{'is-hidden': !(hasMoreData && applySearchOnType)}">
        <a @click="doFind(pendaftars.length)">{{ $t("label.load_more") }}</a>
      </div>
    </g-autocomplete>
  </g-field>
</template>

<script lang="ts">
import { Component, Vue, Watch, Prop, Container } from "annotation";
import cloneDeep from "lodash/cloneDeep";
import debounce from "lodash/debounce";
import AppConfig from "../../../AppConfig";
import environment from "environment";
import Response from "../../../service/Response";
import PendaftarService from "../../../service/PendaftarService";
import Pendaftar from "../../../entity/Pendaftar";

@Component
export default class PendaftarAutoComplete extends Vue {

  private get pendaftarService(): PendaftarService {
    return Container.get(PendaftarService);
  }

  @Prop({
    default: () => {
      return AppConfig.getVm().$t("label.nama_pendaftar");
    }
  })
  public placeholder: any;

  @Prop({
    default: () => AppConfig.getVm().$t("label.nama_pendaftar")
  })
  public title: any;

  @Prop({ type: String, default: "" })
  public pendaftarName: string;

  @Prop({ type: String, default: null })
  public type: any;

  @Prop({ type: String, default: null })
  public message: any;

  @Prop({ type: Boolean, default: false })
  public applySearchOnType: boolean;

  public pendaftarNameFormated: string = "";

  public isLoading: boolean = false;

  public hasMoreData: boolean = false;

  @Watch("pendaftarName", { immediate: true })
  public onPendaftarNameChange(val: string) {
    if (val) {
      this.pendaftarNameFormated = val;
    }
  }

  @Watch("pendaftarNameFormated")
  public onPendaftarNameFormatedChange() {
    console.log('[DEBUG-PENDAFTAR] watcher pendaftarNameFormated triggered:', this.pendaftarNameFormated);
    if (this.applySearchOnType) {
      console.log('[DEBUG-PENDAFTAR] calling onTypingPendaftar');
      this.onTypingPendaftar();
    }
  }

  @Watch("applySearchOnType", { immediate: true })
  public onApplySearchOnType(val: boolean) {
    console.log('[DEBUG-PENDAFTAR] watcher applySearchOnType triggered:', val);
    if (val) {
      this.doFind();
    }
  }

  private pendaftars: Array<Pendaftar> = [];

  public get pendaftarFilter() {
    const filteredPendaftar: Array<any> = this.pendaftars.filter((item: Pendaftar) => {
      let { nama_lengkap } = item;

      return nama_lengkap.toLowerCase().includes(this.pendaftarNameFormated.toLowerCase());
    });

    return filteredPendaftar.length > 0 ? filteredPendaftar : this.pendaftars;
  }

  public mounted() {
    console.log('[DEBUG-PENDAFTAR] mounted');
    if (!this.applySearchOnType) {
      this.doFind();
    }
  }

  public async doFind(page: number = 0) {
    console.log('[DEBUG-PENDAFTAR] doFind called, page:', page, 'applySearchOnType:', this.applySearchOnType);
    if (!this.applySearchOnType) this.isLoading = true;

    const fixedLimit: number = environment[this.applySearchOnType ? "LIMIT" : "MAX_LIMIT"];
    let fixedPage: number = page;

    if (fixedPage > 0) {
      fixedPage = Math.ceil(fixedPage / fixedLimit);
    }

    const param: any = { page: fixedPage, size: fixedLimit };

    if (this.applySearchOnType && this.pendaftarNameFormated.length >= environment["MAX_CHAR_SEARCH_NAME"]) {
      param["nama"] = this.pendaftarNameFormated;
    }
    
    console.log('[DEBUG-PENDAFTAR] calling service with param:', JSON.stringify(param));

    const response: Response = await this.pendaftarService.findDaftarBiaya(param);
    
    console.log('[DEBUG-PENDAFTAR] service response:', response);

    if (response.isSuccess) {
      if (this.applySearchOnType) {
        response.getDeserializeResponse([]).forEach((item: Pendaftar) => this.pendaftars.push(item));

        this.hasMoreData = this.pendaftars.length < response.getRows(0);
      } else {
        this.pendaftars = response.getDeserializeResponse([]);
      }
    }

    if (!this.applySearchOnType) this.isLoading = false;
  }

  public onSelectStaff(pendaftar: Pendaftar) {
    if (pendaftar) {
      console.log('[DEBUG-PENDAFTAR] pendaftar selected:', pendaftar);
      this.$emit("select-pendaftar", cloneDeep(pendaftar));
    }
  }

  public onResetOnTypeSearch() {
    this.pendaftarNameFormated = "";
    this.isLoading = true;

    this.doFind().then(() => this.isLoading = false);
  }

  public created() {
    console.log('[DEBUG-PENDAFTAR] created hook');
    this.onTypingPendaftar = debounce(() => {
      console.log('[DEBUG-PENDAFTAR] debounce function executed. name length:', this.pendaftarNameFormated.length);
      if (this.pendaftarNameFormated.length < environment["MAX_CHAR_SEARCH_NAME"]) {
         console.log('[DEBUG-PENDAFTAR] name too short, skipping');
        return;
      }

      this.isLoading = true;
      this.pendaftars = [];
      this.doFind().then(() => this.isLoading = false);
    }, 500);
    console.log('[DEBUG-PENDAFTAR] onTypingPendaftar initialized:', !!this.onTypingPendaftar);
  }

  public onTypingPendaftar: any;
}
</script>
